"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CheckOutPageHeader;
(function (CheckOutPageHeader) {
    CheckOutPageHeader["Address"] = "Please provide the following addresses before proceeding";
})(CheckOutPageHeader = exports.CheckOutPageHeader || (exports.CheckOutPageHeader = {}));
var CheckoutStep;
(function (CheckoutStep) {
    CheckoutStep["CART"] = "Cart";
    CheckoutStep["DETAILS"] = "Details";
    CheckoutStep["ADDRESS"] = "Address";
    CheckoutStep["PAYMENT"] = "Payment";
    CheckoutStep["ADMIN_PAYMENT_OPTIONS"] = "admin_payment_options";
    CheckoutStep["ADMIN_OFFLINE_PAYMENT"] = "admin_offline_payment";
    CheckoutStep["ADMIN_ECKOH_PAYMENT"] = "admin_eckoh_payment";
    CheckoutStep["CENTER_MEMBERSHIP_PAYMENT_OPTIONS"] = "center_membership_payment";
})(CheckoutStep = exports.CheckoutStep || (exports.CheckoutStep = {}));
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["ECHECK_DEBIT"] = "eCheck";
    PaymentMethods["PAYPAL"] = "PayPal";
    PaymentMethods["CARD"] = "Debit/Credit Card";
    PaymentMethods["ECHECK_DEBIT_COMPLETE_NAME"] = "eCheck Debit";
})(PaymentMethods = exports.PaymentMethods || (exports.PaymentMethods = {}));
var CTCustomerUpdate;
(function (CTCustomerUpdate) {
    CTCustomerUpdate["USER_DETAILS"] = "updateCustomerDetails";
    CTCustomerUpdate["CONFERENCE_USER_INFO"] = "updateCustomerConferenceInfo";
})(CTCustomerUpdate = exports.CTCustomerUpdate || (exports.CTCustomerUpdate = {}));
var AqaRequirementConstants;
(function (AqaRequirementConstants) {
    AqaRequirementConstants["AUDIO"] = "Audio";
    AqaRequirementConstants["VISIBILITY"] = "Visibility";
    AqaRequirementConstants["MOBILITY"] = "Mobility";
})(AqaRequirementConstants = exports.AqaRequirementConstants || (exports.AqaRequirementConstants = {}));
var DietaryRequirementConstants;
(function (DietaryRequirementConstants) {
    DietaryRequirementConstants["KOSHER"] = "Kosher";
    DietaryRequirementConstants["HALAL"] = "Halal";
    DietaryRequirementConstants["VEGETARIAN"] = "Vegetarian";
    DietaryRequirementConstants["VEGAN"] = "Vegan";
    DietaryRequirementConstants["DAIRY_FREE"] = "Dairy-free";
    DietaryRequirementConstants["GLUTEN_FREE"] = "Gluten-free";
    DietaryRequirementConstants["NUT_ALLERGY"] = "Nut allergy";
})(DietaryRequirementConstants = exports.DietaryRequirementConstants || (exports.DietaryRequirementConstants = {}));
var ShippingTypeKey;
(function (ShippingTypeKey) {
    ShippingTypeKey["STANDARD"] = "standard";
    ShippingTypeKey["PRIORITY"] = "priority";
    ShippingTypeKey["INTERNATIONAL"] = "international";
    ShippingTypeKey["INTERNATIONAL_WITH_MAGAZINE"] = "international_with_magazine";
})(ShippingTypeKey = exports.ShippingTypeKey || (exports.ShippingTypeKey = {}));
var ShippingTypeName;
(function (ShippingTypeName) {
    ShippingTypeName["STANDARD"] = "Standard";
    ShippingTypeName["PRIORITY"] = "Priority";
    ShippingTypeName["INTERNATIONAL"] = "International";
    ShippingTypeName["INTERNATIONAL_WITH_MAGAZINE"] = "International with Magazine";
})(ShippingTypeName = exports.ShippingTypeName || (exports.ShippingTypeName = {}));
var ShippingTypeLocationForAnalytics;
(function (ShippingTypeLocationForAnalytics) {
    ShippingTypeLocationForAnalytics["DOMESTIC"] = "Domestic";
    ShippingTypeLocationForAnalytics["INTERNATIONAL"] = "International";
})(ShippingTypeLocationForAnalytics || (ShippingTypeLocationForAnalytics = {}));
exports.ShippingTypeNameByKeyMap = {
    [ShippingTypeKey.STANDARD]: ShippingTypeName.STANDARD,
    [ShippingTypeKey.PRIORITY]: ShippingTypeName.PRIORITY,
    [ShippingTypeKey.INTERNATIONAL]: ShippingTypeName.INTERNATIONAL,
    [ShippingTypeKey.INTERNATIONAL_WITH_MAGAZINE]: ShippingTypeName.INTERNATIONAL,
};
exports.ShippingTypeNameByMethodNameMap = {
    [ShippingTypeName.STANDARD]: ShippingTypeName.STANDARD,
    [ShippingTypeName.PRIORITY]: ShippingTypeName.PRIORITY,
    [ShippingTypeName.INTERNATIONAL]: ShippingTypeName.INTERNATIONAL,
    [ShippingTypeName.INTERNATIONAL_WITH_MAGAZINE]: ShippingTypeName.INTERNATIONAL,
};
exports.ShippingLocationForAnalyticsMap = {
    [ShippingTypeName.STANDARD]: ShippingTypeLocationForAnalytics.DOMESTIC,
    [ShippingTypeName.PRIORITY]: ShippingTypeLocationForAnalytics.DOMESTIC,
    [ShippingTypeName.INTERNATIONAL]: ShippingTypeLocationForAnalytics.INTERNATIONAL,
    [ShippingTypeName.INTERNATIONAL_WITH_MAGAZINE]: ShippingTypeLocationForAnalytics.INTERNATIONAL,
};
exports.ShippingTypeNameAnalyticsByMethodNameMap = {
    [ShippingTypeName.STANDARD]: ShippingTypeName.STANDARD,
    [ShippingTypeName.PRIORITY]: ShippingTypeName.PRIORITY,
    [ShippingTypeName.INTERNATIONAL]: ShippingTypeName.STANDARD,
    [ShippingTypeName.INTERNATIONAL_WITH_MAGAZINE]: ShippingTypeName.INTERNATIONAL_WITH_MAGAZINE,
};
var CountriesFeatureToggleConstants;
(function (CountriesFeatureToggleConstants) {
    CountriesFeatureToggleConstants["BLOCKED"] = "blocked";
})(CountriesFeatureToggleConstants = exports.CountriesFeatureToggleConstants || (exports.CountriesFeatureToggleConstants = {}));
var CheckoutCountriesListToggle;
(function (CheckoutCountriesListToggle) {
    CheckoutCountriesListToggle["USE_ADDITIONAL_COUNTRIES"] = "useAdditionalCountries";
    CheckoutCountriesListToggle["USE_PART_2_ADDITIONAL_COUNTRIES"] = "usePart2AdditionalCountries";
    CheckoutCountriesListToggle["USE_UKRAINE"] = "useUkraine";
    CheckoutCountriesListToggle["USE_CZECH_REPUBLIC"] = "useCzechRepublic";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_1"] = "useNonUSBatch1";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_2"] = "useNonUSBatch2";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_3"] = "useNonUSBatch3";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_4"] = "useNonUSBatch4";
    CheckoutCountriesListToggle["USE_US_TERRITORIES_1"] = "useUSTerritories1";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_5"] = "useNonUSBatch5";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_6"] = "useNonUSBatch6";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_7"] = "useNonUSBatch7";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_8"] = "useNonUSBatch8";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_9"] = "useNonUSBatch9";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_10"] = "useNonUSBatch10";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_12"] = "useNonUSBatch12";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_11"] = "useNonUSBatch11";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_13"] = "useNonUSBatch13";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_14"] = "useNonUSBatch14";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_15"] = "useNonUSBatch15";
    CheckoutCountriesListToggle["USE_NON_US_BATCH_16"] = "useNonUSBatch16";
    CheckoutCountriesListToggle["USE_NON_US_RUSSIA"] = "useNonUS_Russia";
    CheckoutCountriesListToggle["USE_AICPA_VERY_HIGH_RISK_B2C"] = "useAICPAveryhighriskB2C";
    CheckoutCountriesListToggle["USE_AICPA_VERY_HIGH_RISK_B2B"] = "useAICPAveryhighriskB2B";
    CheckoutCountriesListToggle["USE_CIMA_VERY_HIGH_RISK_B2C"] = "useCIMAveryhighriskB2C";
    CheckoutCountriesListToggle["USE_CIMA_VERY_HIGH_RISK_B2B"] = "useCIMAveryhighriskB2B";
    CheckoutCountriesListToggle["USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C"] = "useAICPAveryhighriskApprovedB2C";
    CheckoutCountriesListToggle["USE_AICPA_VERY_HIGH_RISK_APPROVED_B2B"] = "useAICPAveryhighriskApprovedB2B";
    CheckoutCountriesListToggle["USE_AFGHANISTAN"] = "useAfghanistan";
    CheckoutCountriesListToggle["USE_COLOMBIA"] = "useColombia";
    CheckoutCountriesListToggle["USE_BOSNIA_HERZEGOVINA"] = "useBosnia&Herzegovina";
})(CheckoutCountriesListToggle = exports.CheckoutCountriesListToggle || (exports.CheckoutCountriesListToggle = {}));
var Tiers;
(function (Tiers) {
    Tiers["TIER1"] = "tier1";
    Tiers["TIER2"] = "tier2";
    Tiers["TIER3"] = "tier3";
    Tiers["RESTRICTED"] = "restricted";
})(Tiers = exports.Tiers || (exports.Tiers = {}));
var PaypalActions;
(function (PaypalActions) {
    PaypalActions["PROCEED"] = "proceed";
    PaypalActions["CANCELLED"] = "cancelled";
})(PaypalActions = exports.PaypalActions || (exports.PaypalActions = {}));
//# sourceMappingURL=index.js.map